import { access_integrationsNodes } from './access-integrations';
import { ai_nodesNodes } from './ai-nodes';
import { databaseNodes } from './database';
import { filesNodes } from './files';
import { flow_controlNodes } from './flow-control';
import { integrationsNodes } from './integrations';
import { responsesNodes } from './responses';
import { triggersNodes } from './triggers';
import { utilitiesNodes } from './utilities';
import { webNodes } from './web';
import toolsNodes from './tools';

export const ALL_NODE_MODULES = {
  ...access_integrationsNodes,
  ...ai_nodesNodes,
  ...databaseNodes,
  ...filesNodes,
  ...flow_controlNodes,
  ...integrationsNodes,
  ...responsesNodes,
  ...triggersNodes,
  ...utilitiesNodes,
  ...webNodes,
  ...toolsNodes,
};

// Extract definitions from modules
export const ALL_NODE_DEFINITIONS = Object.entries(ALL_NODE_MODULES).reduce(
  (acc, [nodeType, nodeModule]) => {
    if ('definition' in nodeModule && nodeModule.definition) {
      acc[nodeType] = nodeModule.definition;
    }
    return acc;
  },
  {} as Record<string, any>
);

// Extract schemas from modules
export const ALL_NODE_SCHEMAS = Object.entries(ALL_NODE_MODULES).reduce(
  (acc, [nodeType, nodeModule]) => {
    if ('schema' in nodeModule && nodeModule.schema) {
      acc[nodeType] = nodeModule.schema;
    }
    return acc;
  },
  {} as Record<string, any>
);

// Extract properties from modules (UI property schemas)
export const ALL_NODE_PROPERTIES = Object.entries(ALL_NODE_MODULES).reduce(
  (acc, [nodeType, nodeModule]) => {
    if ('properties' in nodeModule && nodeModule.properties) {
      acc[nodeType] = nodeModule.properties;
    }
    return acc;
  },
  {} as Record<string, any>
);

// Extract defaults from modules
export const ALL_NODE_DEFAULTS = Object.entries(ALL_NODE_MODULES).reduce(
  (acc, [nodeType, nodeModule]) => {
    if ('defaults' in nodeModule && nodeModule.defaults) {
      acc[nodeType] = nodeModule.defaults;
    }
    return acc;
  },
  {} as Record<string, any>
);

// Extract validators from modules
export const ALL_NODE_VALIDATORS = Object.entries(ALL_NODE_MODULES).reduce(
  (acc, [nodeType, nodeModule]) => {
    if ('validator' in nodeModule && nodeModule.validator) {
      acc[nodeType] = nodeModule.validator;
    }
    return acc;
  },
  {} as Record<string, any>
);

export function getAllNodeDefinitions() {
  return ALL_NODE_DEFINITIONS;
}
